import React from "react";

const DefaultEuropeanAccessibilityAct = ({
  lang,
  companyName,
  domain,
  phone,
  address,
}: {
  lang: string;
  companyName: string;
  domain: string;
  phone: string;
  address: React.ReactNode;
}) => {
  if (lang === "de") {
    return (
      <div className="min-h-full px-5 text-foreground gap-4 flex flex-col">
        <h1 className="font-semibold text-foreground/90 text-2xl leading-[28px] tracking-[-0.015em] text-center mb-6">
          Barrierefreiheit
        </h1>
        <h2 className="font-semibold text-lg mt-6">Stand der Erklärung</h2>
        <p className="underline">11.07.2025</p>
        <p>
          {address} ist bemüht, die Web-App <b>{domain}</b> im Einklang mit dem
          Barrierefreiheit (BFSG) sowie der EU-Richtlinie (EU)
          2019/882 über die Barrierefreiheitsanforderungen für Produkte und
          Dienstleistungen barrierefrei zugänglich zu machen.
        </p>
        <h2 className="font-semibold text-lg mt-6">Geltungsbereich</h2>
        <p>Diese Erklärung zur Barrierefreiheit gilt für die Web-App:</p>
        <p>
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href={`https://${domain}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            https://{domain}
          </a>
        </p>
        <h2 className="font-semibold text-lg mt-6">
          Stand der Vereinbarkeit mit den Anforderungen
        </h2>
        <p>
          Die Web-App ist: <br />
          {/* 🟩 vollständig vereinbar <br /> */}
          🟨 überwiegend vereinbar <br />
          {/* 🟥 teilweise vereinbar <br /> */}
          mit den Anforderungen des BFSG.
        </p>
        <p></p>
        <p>
          Diese Einschätzung basiert auf einer durchgeführten
          Konformitätsbewertung gemäß § 13 BFSG, durchgeführt am 11. Juli 2025.
        </p>
        {/* <h2 className="font-semibold text-lg mt-6">
          Nicht barrierefreie Inhalte
        </h2>
        <p>Folgende Inhalte sind derzeit nicht barrierefrei:</p>
        <ul>
          <li>
            [Beispiel: Einzelne Schaltflächen sind nicht ausreichend per
            Tastatur erreichbar.]
          </li>
          <li>[Beispiel: Fehlende Alternativtexte bei Grafiken.]</li>
          <li>
            [Beispiel: Farbkontraste entsprechen nicht den
            Mindestanforderungen.]
          </li>
        </ul>
        <p>
          Wir arbeiten kontinuierlich daran, bestehende Barrieren zu
          identifizieren und zu beseitigen.
        </p> */}
        <h2 className="font-semibold text-lg mt-6">Feedback und Kontakt</h2>
        <p>
          Wenn Sie auf Barrieren stoßen oder Anregungen zur Verbesserung der
          digitalen Barrierefreiheit haben, freuen wir uns über Ihre Nachricht:
        </p>
        <p>
          📧 E-Mail:{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href="mailto:barrierefreiheit@kolula.com"
          >
            barrierefreiheit@kolula.com
          </a>{" "}
          <br />
          📞 Telefon:{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href={`callto:${phone}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {phone}
          </a>{" "}
          <br />
          📬 Postanschrift: <br />
          <address>
            kolula solutions UG (haftungsbeschränkt)
            <br />
            c/o SchneiderGolling & Cie. AG
            <br />
            Niederkasseler Lohweg 18
            <br />
            40547 Düsseldorf
          </address>
        </p>
        <h2 className="font-semibold text-lg mt-6">Durchsetzungsverfahren</h2>
        <p>
          Sollten Sie innerhalb von sechs Wochen keine zufriedenstellende
          Antwort auf Ihre Anfrage erhalten haben, können Sie sich an die
          Durchsetzungsstelle wenden:
        </p>
        <p>
          <address>
            Bundesfachstelle Barrierefreiheit - Durchsetzungsstelle
            Barrierefreie Informationstechnik
            <br />
            Mauerstraße 53
            <br />
            10117 Berlin
          </address>
          <br />
          Kontakt:{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href="https://www.bfit-bund.de/DE/Kontakt/kontakt_node.html"
          >
            https://www.bfit-bund.de/DE/Kontakt/kontakt_node.html
          </a>
          <br />
          <br />
          E-Mail:{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href="mailto:kontakt@bfit-bund.de"
          >
            kontakt@bfit-bund.de
          </a>
        </p>
        <p>© {companyName}, 2025</p>
        <br />
        <br />
      </div>
    );
  } else {
    return (
      <div className="min-h-full px-5 text-foreground gap-4 flex flex-col">
        <h1 className="font-semibold text-foreground/90 text-2xl leading-[28px] tracking-[-0.015em] text-center mb-6">
          Accessibility
        </h1>
        <h2 className="font-semibold text-lg mt-6">
          Status of this declaration
        </h2>
        <p className="underline">11.07.2025</p>
        <p>
          {address} strives to make the web app <b>{domain}</b> accessible in
          accordance with the Accessibility (BFSG) and EU
          Directive (EU) 2019/882 on accessibility requirements for products and
          services.
        </p>
        <h2 className="font-semibold text-lg mt-6">Scope of application</h2>
        <p>This accessibility statement applies to the web app:</p>
        <p>
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href={`https://${domain}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            https://{domain}
          </a>
        </p>
        <h2 className="font-semibold text-lg mt-6">
          Degree of compliance with the requirements
        </h2>
        <p>
          The web app is: <br />
          {/* 🟩 fully compliant <br /> */}
          🟨 mostly compliant <br />
          {/* 🟥 partially compliant <br /> */}
          with the requirements of the BFSG.
        </p>
        <p></p>
        <p>
          This assessment is based on a conformity evaluation in accordance with
          § 13 BFSG, conducted on 11. July 2025.
        </p>
        {/* <h2 className="font-semibold text-lg mt-6">Non-accessible content</h2>
        <p>The following content is currently not accessible:</p>
        <ul>
          <li>
            [Example: Certain buttons are not sufficiently accessible via
            keyboard.]
          </li>
          <li>[Example: Missing alternative text for images.]</li>
          <li>
            [Example: Color contrasts do not meet the minimum requirements.]
          </li>
        </ul>
        <p>
          We are continuously working to identify and eliminate existing
          barriers.
        </p> */}
        <h2 className="font-semibold text-lg mt-6">Feedback and contact</h2>
        <p>
          If you encounter any barriers or have suggestions for improving
          digital accessibility, we welcome your message:
        </p>
        <p>
          📧 Email:{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href="mailto:barrierefreiheit@kolula.com"
          >
            barrierefreiheit@kolula.com
          </a>{" "}
          <br />
          📞 Phone:{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href={`callto:${phone}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {phone}
          </a>{" "}
          <br />
          📬 Postal address: <br />
          <address>
            kolula solutions UG (limited liability)
            <br />
            c/o SchneiderGolling & Cie. AG
            <br />
            Niederkasseler Lohweg 18
            <br />
            40547 Düsseldorf
          </address>
        </p>
        <h2 className="font-semibold text-lg mt-6">Enforcement procedure</h2>
        <p>
          If you have not received a satisfactory response to your inquiry
          within six weeks, you can contact the enforcement body:
        </p>
        <p>
          <address>
            Federal Accessibility Agency – Enforcement Body for Accessible
            Information Technology
            <br />
            Mauerstraße 53
            <br />
            10117 Berlin
          </address>
          <br />
          Contact:{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href="https://www.bfit-bund.de/DE/Kontakt/kontakt_node.html"
          >
            https://www.bfit-bund.de/DE/Kontakt/kontakt_node.html
          </a>
          <br />
          <br />
          Email:{" "}
          <a
            className="underline underline-offset-2 hover:decoration-primary"
            href="mailto:kontakt@bfit-bund.de"
          >
            kontakt@bfit-bund.de
          </a>
        </p>
        <p>© {companyName}, 2025</p>
        <br />
        <br />
      </div>
    );
  }
};

export default DefaultEuropeanAccessibilityAct;
